module.exports = __webpack_public_path__ + "img/cocgq.162778e3.png";